import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../../assets/logosnake.jpg";
import "./Sidebar.css";
import ConfirmationModal from "../MiniComponents/ConfirmationModal";
import { useNavigate } from "react-router-dom";

import {
  MdDashboard,
  MdPeople,
  MdSportsEsports,
  MdInventory,
  MdLeaderboard,
  MdNotifications,
  MdSettings,
  MdContactSupport,
  MdLogout,
  MdMenu,
  MdClose,
  MdVideoSettings,
} from "react-icons/md";

import { getAdminProfile } from "../../api/adminSettingsApi";

const Sidebar = () => {
  const [admin, setAdmin] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [openLogoutModal, setOpenLogoutModal] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    fetchAdminProfile();
  }, []);

  const fetchAdminProfile = async () => {
    try {
      const res = await getAdminProfile();
      console.log("profile get response :", res);
      setAdmin(res.data);
    } catch (err) {
      console.error("Failed to fetch admin profile", err);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    navigate("/");
  };

  return (
    <>
      {/* Hamburger Button */}
      <button className="hamburger-btn" onClick={() => setIsOpen(true)}>
        <MdMenu />
      </button>

      {/* Overlay */}
      {isOpen && (
        <div className="sidebar-overlay" onClick={() => setIsOpen(false)} />
      )}

      <aside className={`sidebar ${isOpen ? "open" : ""}`}>
        {/* Close Button (Mobile) */}
        <button className="close-btn" onClick={() => setIsOpen(false)}>
          <MdClose />
        </button>

        {/* Logo */}
        <div className="sidebar-logo">
          <img src={Logo} alt="Snake Slither" />
        </div>

        {/* Menu */}
        <nav className="sidebar-menu">
          {/* <NavLink
            to="/Layout/Dashboard"
            className="menu-item"
            onClick={() => setIsOpen(false)}
          >
            <MdDashboard /> <span>Dashboard</span>
          </NavLink> */}

          <NavLink
            to="/Layout/Users"
            className="menu-item"
            onClick={() => setIsOpen(false)}
          >
            <MdPeople /> <span>Users</span>
          </NavLink>

          {/* <NavLink
            to="/Layout/Games"
            className="menu-item"
            onClick={() => setIsOpen(false)}
          >
            <MdSportsEsports /> <span>Games</span>
          </NavLink> */}

          <NavLink
            to="/Layout/SalesInventory"
            className="menu-item"
            onClick={() => setIsOpen(false)}
          >
            <MdInventory /> <span>Sales & Inventory</span>
          </NavLink>

          <NavLink
            to="/Layout/Leaderboard"
            className="menu-item"
            onClick={() => setIsOpen(false)}
          >
            <MdLeaderboard /> <span>Leaderboard</span>
          </NavLink>

          <NavLink
            to="/Layout/Ads"
            className="menu-item"
            onClick={() => setIsOpen(false)}
          >
            <MdVideoSettings /> <span>Ads</span>
          </NavLink>

          <NavLink
            to="/Layout/Notifications"
            className="menu-item"
            onClick={() => setIsOpen(false)}
          >
            <MdNotifications /> <span>Notification</span>
          </NavLink>

          <NavLink
            to="/Layout/AdminSettings"
            className="menu-item"
            onClick={() => setIsOpen(false)}
          >
            <MdSettings /> <span>Admin Setting</span>
          </NavLink>

          <NavLink
            to="/Layout/ContactQueries"
            className="menu-item"
            onClick={() => setIsOpen(false)}
          >
            <MdContactSupport /> <span>Contact Queries</span>
          </NavLink>
        </nav>

        {/* Bottom Section */}
        <div className="bottom-section">
          <button
            onClick={() => setOpenLogoutModal(true)}
            className="logout-btn"
          >
            <MdLogout /> Log out
          </button>

          {/* <div className="user-card">
            {admin?.profileImage ? (
              <img
                src={admin.profilePic}
                alt="Profile"
                className="user-avatar"
              />
            ) : (
              <div className="user-avatar-fallback">
                {admin?.username?.charAt(0).toUpperCase()}
                
              </div>
            )}

            <div className="user-info">
              <p className="user-name">
                {admin?.firstName} {admin?.lastName}
              </p>
              <p className="user-role">{admin?.role}</p>
            </div>
          </div> */}
        </div>
      </aside>
      {openLogoutModal && (
        <ConfirmationModal
          title="Are You sure want to Logout?"
          onConfirm={handleLogout}
          onCancel={() => setOpenLogoutModal(false)}
        />
      )}
    </>
  );
};

export default Sidebar;
